import { render, staticRenderFns } from "./i-footer.vue?vue&type=template&id=a1ef5f3e&scoped=true&"
import script from "./i-footer.vue?vue&type=script&lang=js&"
export * from "./i-footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ef5f3e",
  null
  
)

export default component.exports